import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCamera5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCamera5"><Path d="M6.5 16.5H9.5M10.5 4.5H2.5V20.5H21.5V15.5M12.5 4.5H21.5V13.5H12.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M17 9V8.99M17.25 9C17.25 9.13807 17.1381 9.25 17 9.25C16.8619 9.25 16.75 9.13807 16.75 9C16.75 8.86193 16.8619 8.75 17 8.75C17.1381 8.75 17.25 8.86193 17.25 9Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconCamera5;
